module.exports = __webpack_public_path__ + "img/2.746d77ab.png";